import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReframe: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="reframe, 3D, scale"><path d="M7.375 4.27767L12 1.60742L16.625 4.27767M21.25 12.2884V17.6289L16.625 20.2991M7.375 20.2991L2.75 17.6289V12.2884" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.9998 2.60742V12M11.9998 12L3.22266 17.3411M11.9998 12L20.5 17.1726" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconReframe;
